import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

const StatusCard = ({
  title,
  description,
  status,
  statusType = "text", 
  statusColor = "green",
  additionalInfo = [],
  actions,
  className = "",
}) => {
  return (
    <div className="card-wrapper">
      <Card className={`node-card ${className}`}>
        <CardHeader>
          <CardTitle>{title}</CardTitle>
          <CardDescription>{description}</CardDescription>
        </CardHeader>
        <CardContent className="space-y-2">
          <div>
            {statusType === "badge" ? (
              <Badge variant="outline" className={`bg-${statusColor}-100 text-${statusColor}-700 border-${statusColor}-200`}>
                {(status ? status.toUpperCase() : "NODE' A ERİŞİM YOK")}
              </Badge>
            ) : (
              <span className={`text-${statusColor}-600`}>{status}</span>
            )}
          </div>
          {additionalInfo.map((info, index) => (
            <div key={index}>
              <strong>{info.label}:</strong> {info.value}
            </div>
          ))}
          {actions && (
            <div className="flex justify-end gap-2">
              {actions.map((action, index) => (
                <div
                  key={index}
                  onClick={action.onClick}
                  className="cursor-pointer"
                >
                  {action.icon}
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default StatusCard; 